import { PriceDirectionNullable } from "../../../../../../../../../../services/cloudchipr.api";

export const costAnomaliesWidgetSortingOrderLabels: Map<
  PriceDirectionNullable,
  string
> = new Map([
  ["increasing", "Increase"],
  ["decreasing", "Decrease"],
]);
